<template>
    <div class="card">
        <!--cabezera-->
        <div class="card-header">

            <div class="d-flex">
                <div class="flex-fill">
                    <DocumentNotificationSearch></DocumentNotificationSearch>
                </div>

                <div class="float-end">
                    <DocumentPagination></DocumentPagination>
                </div>

            </div>

        </div>

        <!--cuerpo-->
        <div class="card-body">

            <DocumentNotificationTable></DocumentNotificationTable>

        </div>
    </div>
</template>
<script>
import DocumentNotificationTable from '@/components/DocumentRepository/DocumentMenu/DocumentNotification/Document-notification-table.vue'
import DocumentNotificationSearch from '@/components/DocumentRepository/DocumentMenu/DocumentNotification/Document-notification-search.vue'
import DocumentPagination from '@/components/DocumentRepository/DocumentMenu/DocumentNotification/Document-notification-pagination.vue'

export default {
    name: 'DocumentNotification',

    components: {
        DocumentNotificationTable,
        DocumentNotificationSearch,
        DocumentPagination
    }
}
</script>
<style></style>